<template>
  <v-tooltip
    top
  >
    <template v-slot:activator="{ on }">
      <v-chip
        label
        outlined
        small
        :color="color"
        class="caption mr-1 mb-1"
        v-on="on"
      >
        <span
          v-if="!trainingLoad && trainingLoad !== 0"
          class="grey--text"
        >
          N/A
        </span>
        <span v-else>
          <span class="grey--text">{{ $dayjs(eventStartAt).tz(playerTimezone || undefined).format(getDateTimeFormatForUser('HH:mm')) }}</span>
          &middot;
          <span class="grey--text">
            {{ trainingDuration || $dayjs(eventEndAt).diff($dayjs(eventStartAt), 'm') }} {{ $t('suffixes.min') }}
          </span>
          <span
            v-if="trainingGrade"
            class="grey--text"
          >
            TG {{ trainingGrade }}
          </span>
          &middot;
          <span class="font-weight-bold">
            {{ !trainingLoad && trainingLoad !== 0 ? 'N/A' : trainingLoad }}
          </span>
        </span>
      </v-chip>
    </template>
    <div>
      <div>{{ eventTitle }} &middot; {{ $dayjs(eventStartAt).tz(playerTimezone || undefined).format(getDateTimeFormatForUser('L HH:mm')) }}</div>
      <div>
        {{ $t('training_load.variable.duration') }} <strong>{{ trainingDuration || $dayjs(eventEndAt).diff($dayjs(eventStartAt), 'm') }} {{ $t('suffixes.min') }}</strong>
      </div>
      <div v-if="trainingGrade !== null">
        {{ $t('training_load.variable.training_grade') }} <strong>{{ trainingGrade }}</strong>
      </div>
      <div v-if="trainingLoad !== null">
        {{ $t('training_load.variable.training_load') }} <strong>{{ trainingLoad }}</strong>
      </div>
      <div v-if="!!sessionEnjoyment">
        {{ $t('training_load.variable.enjoyment') }} <strong>{{ sessionEnjoyment }}</strong>
      </div>
    </div>
  </v-tooltip>
</template>

<script>
import { getColorForValue, getDateTimeFormatForUser } from '@/utils/helpers'

export default {
  name: 'TrainingLoadChip',
  props: {
    eventStartAt: {
      type: String,
      required: true
    },
    eventEndAt: {
      type: String,
      required: true
    },
    eventTitle: {
      type: String,
      required: true
    },
    trainingLoad: {
      type: Number,
      default: undefined
    },
    trainingGrade: {
      type: Number,
      default: undefined
    },
    trainingDuration: {
      type: Number,
      default: undefined
    },
    sessionEnjoyment: {
      type: Number,
      default: undefined
    },
    playerTimezone: {
      type: String,
      default: undefined
    }
  },
  computed: {
    color() {
      if (!this.trainingGrade) return undefined

      return getColorForValue(this.trainingGrade, 10, true)
    }
  },
  methods: { getDateTimeFormatForUser }

}
</script>

<style scoped>

</style>
